import style from "../../Pages/ServicesDisplay.module.css";
import pan from "../images/pancardallotment.png";

const PanCard = () => {
  return (
    <article className={style.ServiceDetailArticle}>
      <h1>Pan Card Allotment</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={pan}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>
          Electronic governance or e-governance is the application of
          information and communication technology (ICT) for delivering
          government services.
        </strong>
        <br /> <br />
        We at centres Exchange the e-Governance services like Pan Card, IRCTC ,
        BBPS and communication transactions, integration of various stand-alone
        systems between government to citizen (G2C), government-to-business
        (G2B), government-to-government (G2G), government-to-employees (G2E) as
        well as back-office processes and interactions within the entire
        government framework. Through e-governance, government services are made
        available to citizens in a convenient, efficient, and transparent
        manner. The three main target groups that can be distinguished in
        governance concepts are government, citizens, and businesses/interest
        groups. In e-governance, there are no distinct boundaries.
      </p>
    </article>
  );
};

export default PanCard;
